import React from "react";
import classNames from "classnames";

import loading_ajax from '../../images/oscilloscope.gif'



const LoadingIndicator = ({ className, ...attrs }) => {
  const classes = classNames(
    className,
    "loading-content",
  );
  return (
    <span className={classes} { ...attrs }>
      <img src={loading_ajax} className="loading-ajax" style={{ height: "100%" }} />
    </span>
  )
};

export default LoadingIndicator;
